import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import { Form, Input, Button, Breadcrumb, Dropdown, Icon, Popup } from 'semantic-ui-react';

import Course from '../modules/lessons/domain/aggregates/course/Course';
import CourseApi from '../modules/lessons/api/CourseApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import LessonApi from '../modules/lessons/api/LessonApi';
import Registry from '../global/Registry';
import {Link} from 'react-router-dom';

interface Props {
	id?: string;
	courseId?: string;
}

interface State {
	lesson?: Lesson;
	lessons: Lesson[];
	courses: Course[];
}

export default class EditLessonPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], courses: [] };
	}

	async componentWillMount () {
		const courses = await CourseApi.getInstance().getAll();
		const lessons = await LessonApi.getInstance().getAll();

		const lessonIdValue = this.props.match.params.id;
		const lesson = lessonIdValue === undefined ? Lesson.create() : lessons.find(lesson => lesson.getId().equals(new EntityId<Lesson>(Number(lessonIdValue)))) as Lesson;

		const courseIdValue = this.props.match.params.courseId;
		if (lessonIdValue === undefined && courseIdValue !== undefined) {
			lesson.updateCourseId(new EntityId<Course>(Number(courseIdValue)));
		}

		this.setState({lesson, lessons, courses});
	}

	protected saveLesson = async (event: Event) => {
		event.preventDefault();

		let lesson = this.state.lesson as Lesson;

		lesson = await LessonApi.getInstance().save(lesson);

		Page.navigate(lesson.getSlug());
	}

	protected isLoading () {
		return this.state.lesson === undefined;
	}

	protected renderTitle () {
		return (this.state.lesson as Lesson).getTitle();
	}

	protected renderDescription () {
		return 'Learn ' + (this.state.lesson as Lesson).getTitle() + ' and other lessons at our digital education platform.';
	}

	protected renderContent () {
		const lesson = this.state.lesson as Lesson;
		const course = this.state.courses.find(course => course.getId().equals(lesson.getCourseId())) as Course;
		const me = Registry.getInstance().me;

		const sections = [
			{ key: 'Home', content: <Link to='/'>Home</Link> },
			{ key: 'Course', content: course.hasId() ? <Link to={course.getSlug()}>{course.getName()}</Link> : course.getName() === '' ? 'New course' : course.getName(), active: !course.hasId() },
			{ key: 'Lesson', content: lesson.getTitle() === '' ? 'New lesson' : lesson.getTitle(), active: true }
		];

		const courseDropdown = (
			<Form.Field>
				<label>Course</label>
				<Dropdown placeholder='Select a course' fluid search selection value={lesson.hasCourseId() ? lesson.getCourseId().getValue() as number : undefined} options={this.state.courses.map((course) => { return {key: course.getId().getValue(), value: course.getId().getValue() as number, text: course.getName()}; })} onChange={(event: any, data: any) => this.setState({lesson: lesson.updateCourseId(new EntityId<Course>(data.value))})} />
			</Form.Field>
		);

		return (
			<div className='lesson'>
				<Breadcrumb icon='right angle' sections={sections} />

				<Form inverted onSubmit={this.saveLesson} style={{marginTop: '24px'}}>
					{me.isErik() && !this.props.match.params.courseId ?  courseDropdown : null}
					<Form.Field>
						<label>{lesson.hasId() ? 'Name' : 'Give your new lesson a name'}</label>
						<Input transparent placeholder='Type a title here' style={{ color: 'white' }} value={lesson.getTitle()} onChange={(event: any) => this.setState({lesson: lesson.updateTitle(event.target.value)})} />
					</Form.Field>
					{me.isErik() ? (
						<div>
							<Form.Field>
								<label>Subtitle</label>
								<Input transparent placeholder='Optional' style={{ color: 'white' }} value={lesson.getSubtitle()} onChange={(event: any) => this.setState({lesson: lesson.updateSubtitle(event.target.value)})} />
							</Form.Field>
							<Form.Field>
								<label>
									Prerequisites
									<Popup hoverable trigger={<Icon name='question circle' />}>
										<Popup.Header>Prerequisites</Popup.Header>
										<Popup.Content>
											<p>
												Prerequisites are lessons that should be finished before taking this lesson.
											</p>
											<p>
												You only need to select <strong>direct</strong> prerequisites.
											</p>
											<p>
												For example, if your lesson is about <strong>long division</strong> and has <strong>addition</strong> and <strong>multiplication</strong> as prerequisites.
												Then you only need to select <strong>multiplication</strong> as a prerequisite here if <strong>addition</strong> is already a prerequisite of <strong>multiplication</strong>.
											</p>
										</Popup.Content>
									</Popup>
								</label>
								{/*<p style={{color: 'grey'; fontSize: '0.8em', textAlign: 'center'}}>Prerequisites are lessons that should be finished before taking this lesson.</p>*/}
								<Dropdown placeholder='Optional' fluid multiple search selection options={this.state.lessons.map((lesson) => { return {key: lesson.getId().getValue(), value: lesson.getId().getValue() as number, text: lesson.getTitle()}; })} onChange={(a, b) => this.setState({lesson: lesson.updatePrerequisiteLessonIds((b.value as Array<number>).map(idValue => new EntityId<Lesson>(idValue)))})} value={lesson.getPrerequisiteLessonIds().map(lessonId => lessonId.getValue() as number)} />
							</Form.Field>
						</div>
					) : null }
					<Form.Field>
						<Button primary fluid style={{marginTop: '2em'}}>Save lesson</Button>
					</Form.Field>
				</Form>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/EditLessonPage.tsx